// 查看会员信息 （会员劵）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>会员劵</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                icon="iconfont icon-fanhui"
                plain
                @click="NvagetToLookMenber"
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @TouchTheBottom="TouchTheBottom"
              @lookDetails="lookDetails"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
              :operation="operation"
            >
              <template slot="operate" slot-scope="scope">
                <el-button
                  @click="Synchronization(scope)"
                  type="text"
                  size="small"
                  style="text-decoration: underline; color: #76734f"
                >
                  同步
                </el-button>
              </template>
            </Table>
          </div>
          <!-- 同步提示框 -->
          <div class="Enabledisable">
            <el-dialog
              width="20%"
              title="同步提示框"
              :visible.sync="EnabledisableFormVisible"
              :close-on-click-modal="false"
            >
              <div style="height: 50px; font-size: 14px; font-weight: 700">
                <p>
                  <i
                    class="iconfont icon-jingshi"
                    style="font-size: 28px; color: #f39b21"
                  ></i>
                  是否真的要<span style="color: #ff0000">同步</span>此会员券?
                </p>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="Enabledisableqd">确 定</el-button>
                <el-button @click="EnabledisableFormVisible = false"
                  >取 消</el-button
                >
              </div>
            </el-dialog>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
    <div>
      <el-dialog
        append-to-body
        width="80%"
        title="券详情"
        :visible.sync="couponDetailsShow"
        :close-on-click-modal="false"
      >
        <quanku ref="quanku"></quanku>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { TApiLogsyncProcess } from "@/api/couponsDepot.js";
import { mapState } from "vuex";
import { GetQueryCustCoupons } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
import quanku from "/src/components/quanku.vue";
export default {
  name: "centre",
  components: {
    Table: Table,
    quanku,
  },
  data() {
    return {
      couponDetailsShow: false,
      EnabledisableFormVisible: false,
      id: "",
      paging: {
        page: 1,
        size: 20,
        total: 0,
        pages: 2,
        Loading: true,
      },
      operation: true,
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "劵编码",
            prop: "coupCode",
            width: 120,
          },
          {
            label: "劵名称",
            prop: "couponsName",
            width: 150,
            operation: "jump_father",
          },
          {
            label: "劵后台名称",
            prop: "innerCoupName",
            width: 160,
          },
          {
            label: "劵包名称",
            prop: "coupPacketName",
            width: 160,
          },
          {
            label: "劵类型",
            prop: "couponsKindText",
            width: 80,
          },
          {
            label: "状态",
            prop: "stateText",
            width: 80,
          },
          {
            label: "生效起始日期",
            prop: "startDate",
            width: 180,
          },
          {
            label: "生效终止日期",
            prop: "endDate",
            width: 180,
          },
          {
            label: "创建人",
            prop: "createUserName",
            width: 100,
          },
          {
            label: "创建日期",
            width: 180,
            prop: "createTime",
          },
          {
            label: "最后修改人",
            prop: "updateUserName",
            width: 100,
          },
          {
            label: "最后修改日期",
            width: 180,
            prop: "udateTime",
          },
        ],
        tbody: [],
      },
    };
  },
  created() {
    this.RGetQueryCustCoupons();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  methods: {
    lookDetails(row) {
      //查看劵详情
      const couponsGrpID = row.couponsGrpID;
      this.couponDetailsShow = true;
      this.$nextTick(() => {
        this.$refs.quanku.RcouponsGroupDetail(couponsGrpID);
      });
    },
    Synchronization(scope) {
      this.id = scope.row.coupID;
      this.EnabledisableFormVisible = true;
    },
    Enabledisableqd() {
      let data = require("qs").stringify({
        id: this.id,
        type: 2,
      });
      TApiLogsyncProcess(data).then((res) => {
        if (res.success == true) {
          this.$message.success("同步成功!");
          this.EnabledisableFormVisible = false;
        } else {
          this.$message.error("同步失败!");
        }
      });
    },
    ReturnState(state) {
      let stateText = "";
      switch (state) {
        case 0:
          stateText = "有效";
          break;
        case 1:
          stateText = "已核销";
          break;
        case 2:
          stateText = "已禁用";
          break;
        case 3:
          stateText = "未发放";
          break;
        case 4:
          stateText = "无效";
          break;
        case 5:
          stateText = "已过期";
          break;
      }
      return stateText;
    },
    ReturnConnpmensState(ConnpmensState) {
      let ConnpmensText = "";
      switch (ConnpmensState) {
        case 0:
          ConnpmensText = "现金券";
          break;
        case 1:
          ConnpmensText = "折扣卷";
          break;
        case 2:
          ConnpmensText = "礼品劵";
          break;
        case 3:
          ConnpmensText = "异业劵";
          break;
      }
      return ConnpmensText;
    },
    RGetQueryCustCoupons() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetQueryCustCoupons(data).then((res) => {
        if (res.success == true) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.couponsKindText = this.ReturnConnpmensState(
              parseInt(item.couponsKind)
            );
            item.stateText = this.ReturnState(parseInt(item.state));
            item.startDate = this.renderTime(item.startDate);
            item.endDate = this.renderTime(item.endDate);
            item.createTime = this.renderTime(item.createTime);
            item.udateTime = this.renderTime(item.udateTime);
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetQueryCustCoupons();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
/deep/.Enabledisable {
  .el-dialog__header,
  .el-message-box__header {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    height: 44px;
    background: #f3f1dd;
    width: 100%;
    text-align: center;
    color: #666;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-dialog__title,
  .el-message-box__title {
    color: #6c6937;
    font-weight: 700;
    font-size: 16px !important;
  }
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coverage-release .el-dialog__body {
    padding: 20px;
  }
  .el-button:hover {
    background-color: #b6b388;
  }
  .el-dialog__body {
    padding: 30px 60px;
  }
  .el-tabs__item {
    border: 1px solid #d9d9d9;
    background-color: #fff;
    color: #6c6937;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .el-tabs__item.is-active {
    color: #6c6937;
    background-color: #f3f1dd;
  }
  .el-form-item__content {
    line-height: 0px;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
